import {ReactComponent as SmsIcon} from './sms.svg'

function Sms() {
  return <SmsIcon />
}

export default Sms
